export const getServiceDetailsFormFields = (t, data = {}) => [
  {
    row: [
      {
        label: t("service_tab_createdBy") || "Created By",
        value: data.createdBy ,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_creationDate") || "Creation Date",
        value: data.creationDate,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_reportDate") || "Report Date",
        value: data.reportDate,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_yearEndDate") || "Year-End Date",
        value: data.yearEndDate,
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label:
          t("service_tab_endDatePeriodCovered") || "End Date of Period covered",
        value: data.endDatePeriodCovered,
        gridClass: "col-md-3",
      },
      {
        label:
          t("service_tab_periodInterimYearEnd") || "Period (Interim/Year-End)",
        value: data.periodInterimYearEnd,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_adn_startDate") || "Engagement Start Date",
        value: data.startDate ,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_adn_endDate") || "Engagement End Date",
        value: data.endDate,
        gridClass: "col-md-3",
      },
      
    ],
  },
  {
    row: [
      {
        label:
          t("service_tab_adn_startDateSubstantiveProcedure") ||
          "Task Start Date",
        value: data.startDateSubstantiveProcedure ,
        gridClass: "col-md-3",
      },
      {
        label:
          t("service_tab_adn_completionDateSubstantiveProcedure") ||
          "Task End Date",
        value: data.completionDateSubstantiveProcedure ,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_adn_revisedStartDate") || "Request Start Date (Revised)",
        value: data.revisedStartDate,
        name: "revisedStartDate",
        type: "date",
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_adn_revisedEndDate") || "Request End Date (Revised)",
        value: data.revisedEndDate,
        name: "revisedEndDate",
        type: "date",
        gridClass: "col-md-3",
      },
    ],
  },
  {
    row: [
      {
        label: t("service_tab_resourceManagerPMO") || "Resource Manager/PMO",
        value: data.resourceManagerPMO,
        tooltip: data.resourceManagerEmail,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_engagementManager") || "Engagement Manager",
        value: data.engagementManager,
        tooltip: data.engagementManagerEmail,
        gridClass: "col-md-3",
      },
      {
        label: t("service_tab_engagementDelegates") || "Engagement Delegates",
        value: data.engagementDelegates,
        type: "delegates",
        gridClass: "col-md-6",
      },
    ],
  },
  {
    row: [
      {
        label: t("service_tab_teamMembers") || "Team Members",
        value: data.teamMembers,
        gridClass: "col-md-3",
      },
    ],
  },
];
